import * as R from "ramda";

import { AccountingPoint, Measurand } from "../domain";
import { levenshteinDistance } from "../../../lib/util";

export function isElectricityP_MAX(m: Measurand) {
  return m.medium === "electricity" && m.symbol.toString() === "P_MAX";
}

export function isElectricityP(m: Measurand) {
  return m.medium === "electricity" && m.symbol.toString() === "P";
}

export function isElectricityE_PEXPORT(m: Measurand) {
  return m.medium === "electricity" && m.symbol.toString() === "E_P,EXPORT";
}

export function isElectricityE_PIMPORT(m: Measurand) {
  return m.medium === "electricity" && m.symbol.toString() === "E_P,IMPORT";
}
export function guessElectricityMainMetersByMeasurands(
  candidates: ReadonlyArray<AccountingPoint>
): Array<AccountingPoint> {
  return candidates.filter(
    (p) =>
      p.measurands.some((m) => isElectricityP_MAX(m)) &&
      p.measurands.some((m) => isElectricityP(m)) &&
      p.measurands.some((m) => isElectricityE_PIMPORT(m))
  );
}

export function guessDefaultMainMeter<T extends { id: string; name: string }>(
  candidates: ReadonlyArray<T>,
  manuallySelectedProsumerId?: string
): T {
  if (manuallySelectedProsumerId != null) {
    const manuallySelectedProsumer = candidates.find((c) => c.id == manuallySelectedProsumerId);
    if (manuallySelectedProsumer) {
      return manuallySelectedProsumer;
    }
  }

  const closestProsumer = R.reduce(
    (closest, current) => {
      const closestDistance = levenshteinDistance(closest.name, "Übergabezähler");
      const currentDistance = levenshteinDistance(current.name, "Übergabezähler");
      return currentDistance < closestDistance ? current : closest;
    },
    candidates[0],
    candidates
  );
  return closestProsumer;
}

export class NoElectricityMainMeterError extends Error {
  constructor() {
    super("NoElectricityMainMeterError");
    this.name = "NoElectricityMainMeterError";
  }
}

export class NoActiveEnergyImportDataError extends Error {
  constructor() {
    super("NoActiveEnergyImportDataError");
    this.name = "NoActiveEnergyImportDataError";
  }
}
